import React, { useState, useEffect, useRef } from 'react';
import { api } from '../api';
import { T, BG } from '../tema';
import { HjaelpIkon } from './Ui';
import { toast } from '../utils';
// ── Moved from App.js: Søgning + FilViewer + OmdøbFilKnap (PR5) ─────
// ─────────────────────────────────────────────────────────
// SØGNING — fritekst + AI
// ─────────────────────────────────────────────────────────
// ── OMDØB FIL KNAP ──────────────────────────────────────
function OmdøbFilKnap({ fil, onGemt }) {
 const [rediger, setRediger] = React.useState(false);
 const [nyt_navn, setNytNavn] = React.useState(fil.visningsnavn || fil.original_navn || "");
 if (!rediger) return (
 <button onClick={e => { e.stopPropagation(); setNytNavn(fil.visningsnavn || fil.original_navn || ""); setRediger(true); }}
 style={{ background:"rgba(255,255,255,0.06)", border:T.skillelinje, borderRadius:7, padding:"7px 14px", color:T.dæmpet, fontSize:12, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif" }}>
 Omdøb
 </button>
 );
 return (
 <div style={{ display:"flex", gap:6, alignItems:"center" }} onClick={e => e.stopPropagation()}> <input value={nyt_navn} onChange={e => setNytNavn(e.target.value)}
 autoFocus spellCheck="true" lang="da"
 className="sv-input"
 style={{ background:"rgba(8,12,30,0.65)", border:`1px solid ${T.turkis}55`, borderRadius:7, padding:"6px 10px", color:T.creme, fontSize:12, fontFamily:"'Inter',system-ui,sans-serif", width:200 }}
 onKeyDown={async e => {
 if (e.key === "Enter" && nyt_navn.trim()) {
 // BUG-FIX 1.3.3: Tjek respons
 const r = await api("filer/" + fil.id, "PATCH", { visningsnavn: nyt_navn.trim() });
 if (!r || r.fejl) { toast("Kunne ikke omdøbe fil: " + (r?.fejl || "serverfejl"), "fejl"); return; }
 onGemt(nyt_navn.trim());
 setRediger(false);
 toast("Filnavn gemt", "success");
 }
 if (e.key === "Escape") setRediger(false);
 }} /> <button onClick={async e => { e.stopPropagation();
 if (nyt_navn.trim()) {
 const r = await api("filer/" + fil.id, "PATCH", { visningsnavn: nyt_navn.trim() });
 if (!r || r.fejl) { toast("Kunne ikke omdøbe fil: " + (r?.fejl || "serverfejl"), "fejl"); return; }
 onGemt(nyt_navn.trim());
 setRediger(false);
 toast("Filnavn gemt", "success");
 }
 }} style={{ background:T.turkis, border:"none", borderRadius:7, padding:"6px 10px", color:"#ffffff", fontSize:12, fontWeight:700, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif" }}>
 Gem
 </button> <button onClick={e => { e.stopPropagation(); setRediger(false); }}
 style={{ background:"none", border:T.skillelinje, borderRadius:7, padding:"6px 10px", color:T.dæmpet, fontSize:12, cursor:"pointer", fontFamily:"'Inter',system-ui,sans-serif" }}>Annullér</button> </div>
 );
}
function FilViewer({ filer, start_index, onLuk }) {
 const [aktiv, setAktiv] = useState(start_index || 0);
 const [vis_navne, setVisNavne] = useState({});
 useEffect(() => {
 const handler = e => { if (e.key === 'Escape') onLuk(); };
 document.addEventListener('keydown', handler);
 return () => document.removeEventListener('keydown', handler);
 }, [onLuk]);
 const fil = filer[aktiv];
 if (!fil) return null;
 const er_pdf = fil.mime_type?.includes("pdf") || fil.original_navn?.endsWith(".pdf");
 const er_billede = fil.mime_type?.includes("image");
 const er_office = fil.mime_type?.includes("word") || fil.mime_type?.includes("excel") || fil.mime_type?.includes("officedocument") || fil.original_navn?.match(/\.(docx?|xlsx?)$/i);
 return (
 <div role="dialog" aria-modal="true" aria-label="Filvisning"
 style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.92)", zIndex:9999, display:"flex", flexDirection:"column" }}
 onClick={onLuk}>
 {/* Header */}
 <div style={{ padding:"14px 20px", display:"flex", alignItems:"center", gap:12, background:"rgba(6,9,20,0.95)", borderBottom:T.skillelinje }}
 onClick={e => e.stopPropagation()}> <button onClick={onLuk} style={{ background:"none", border:"none", color:T.dæmpet, fontSize:20, cursor:"pointer", padding:"0 8px" }}>×</button> <div style={{ flex:1, minWidth:0 }}> <div style={{ fontSize:14, fontWeight:500, color:T.creme, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>
 {vis_navne[fil?.id] || fil?.visningsnavn || fil?.original_navn}
 </div> <div style={{ fontSize:12, color:T.dæmpet }}>{aktiv+1} af {filer.length} filer</div> </div> <div style={{ display:"flex", gap:8 }}>
 {fil.download_url && (
 <a href={fil.download_url} target="_blank" rel="noreferrer" onClick={e => e.stopPropagation()}
 style={{ background:`${T.turkis}20`, border:`1px solid ${T.turkis}44`, borderRadius:7, padding:"7px 14px", color:T.turkis, textDecoration:"none", fontSize:12, fontFamily:"'Inter',system-ui,sans-serif" }}>
 ↓ Download
 </a>
 )}
 <OmdøbFilKnap fil={{...fil, visningsnavn: vis_navne[fil.id] || fil.visningsnavn}} onGemt={(nyt_navn) => {
 setVisNavne(p => ({...p, [fil.id]: nyt_navn}));
 }} /> </div> </div>
 {/* Navigation pile */}
 <div style={{ flex:1, display:"flex", alignItems:"stretch", overflow:"hidden" }} onClick={e => e.stopPropagation()}>
 {/* Venstre pil */}
 <button onClick={() => setAktiv(p => Math.max(0, p-1))} disabled={aktiv === 0}
 style={{ width:56, background:"none", border:"none", color: aktiv===0 ? "rgba(255,255,255,0.08)" : T.dæmpet, fontSize:28, cursor:aktiv===0?"default":"pointer", flexShrink:0 }}>
 ‹
 </button>
 {/* Preview område */}
 <div style={{ flex:1, display:"flex", alignItems:"center", justifyContent:"center", overflow:"auto", padding:16 }}>
 {er_pdf && fil.download_url && (
 <iframe src={fil.download_url} style={{ width:"100%", height:"100%", minHeight:600, border:"none", borderRadius:8, background:"rgba(255,255,255,0.06)" }} title={fil.visningsnavn} />
 )}
 {er_billede && fil.download_url && (
 <img src={fil.download_url} alt={fil.visningsnavn} style={{ maxWidth:"100%", maxHeight:"80vh", borderRadius:8, objectFit:"contain" }} />
 )}
 {er_office && fil.web_url && (
 <iframe
 src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(fil.web_url)}`}
 style={{ width:"100%", height:"100%", minHeight:600, border:"none", borderRadius:8 }}
 title={fil.visningsnavn} />
 )}
 {!er_pdf && !er_billede && !er_office && (
 <div style={{ textAlign:"center", color:T.dæmpet }}> <div style={{ fontSize:48, marginBottom:16 }}></div> <div style={{ fontSize:15, color:T.lys, marginBottom:8 }}>{vis_navne[fil?.id] || fil?.visningsnavn || fil?.original_navn}</div> <div style={{ fontSize:12, marginBottom:20 }}>Denne filtype kan ikke vises direkte</div>
 {fil.download_url && (
 <a href={fil.download_url} target="_blank" rel="noreferrer"
 style={{ background:T.turkis, border:"none", borderRadius:8, padding:"10px 24px", color:"#ffffff", fontWeight:700, fontSize:14, textDecoration:"none", fontFamily:"'Inter',system-ui,sans-serif" }}>
 ↓ Download fil
 </a>
 )}
 </div>
 )}
 </div>
 {/* Højre pil */}
 <button onClick={() => setAktiv(p => Math.min(filer.length-1, p+1))} disabled={aktiv === filer.length-1}
 style={{ width:56, background:"none", border:"none", color: aktiv===filer.length-1 ? "rgba(255,255,255,0.08)" : T.dæmpet, fontSize:28, cursor:aktiv===filer.length-1?"default":"pointer", flexShrink:0 }}>
 ›
 </button> </div>
 {/* Thumbnail strip hvis flere filer */}
 {filer.length > 1 && (
 <div className="sv-thumbnail-strip" style={{ display:"flex", gap:8, padding:"12px 20px", background:"rgba(6,9,20,0.95)", borderTop:T.skillelinje, overflowX:"auto", scrollbarWidth:"thin", scrollbarColor:`${T.turkis}66 rgba(255,255,255,0.05)`, WebkitOverflowScrolling:"touch" }}
 onClick={e => e.stopPropagation()}>
 {filer.map((f, i) => (
 <button key={f.id} onClick={() => setAktiv(i)}
 style={{ flexShrink:0, padding:"6px 12px", borderRadius:7, fontSize:12, fontFamily:"'Inter',system-ui,sans-serif", cursor:"pointer",
 border:`2px solid ${aktiv===i ? T.turkis : "rgba(255,255,255,0.06)"}`,
 background: aktiv===i ? `${T.turkis}18` : "rgba(255,255,255,0.04)",
 color: aktiv===i ? T.turkis : T.dæmpet,
 maxWidth:140, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap",
 }}>
 {f.visningsnavn || f.original_navn}
 </button>
 ))}
 </div>
 )}
 </div>
 );
}
// Gammel HændelseFiler fjernet — erstattet af ny version ovenfor med inline preview
function SøgVisning({ onTilbage, onÅbnSag }) {
 const [søgetekst, setSøgetekst] = useState("");
 const [resultater, setResultater] = useState(null);
 const [indlæser, setIndlæser] = useState(false);
 const [ai_svar, setAiSvar] = useState(null);
 const [ai_indlæser, setAiIndlæser] = useState(false);
 const [ai_fejl, setAiFejl] = useState(null);
 const debounce_ref = useRef(null);
 const abort_ref = useRef(null);
 const input_ref = useRef(null);
 // Autofokus når visning åbner
 useEffect(() => { input_ref.current?.focus(); }, []);
 // Fritekst søgning med debounce + AbortController (cancel stale in-flight requests)
 const kør_fritekst_søg = async (tekst) => {
 const q = (tekst || søgetekst).trim();
 if (q.length < 2) { setResultater(null); return; }
 if (abort_ref.current) abort_ref.current.abort();
 abort_ref.current = new AbortController();
 const signal = abort_ref.current.signal;
 setIndlæser(true);
 try {
 const res = await fetch("/api/soeg?q=" + encodeURIComponent(q), { credentials: 'include', signal });
 if (signal.aborted) return;
 const data = res.ok ? await res.json() : null;
 setResultater(data?.resultater || null);
 } catch (err) {
 if (err?.name !== 'AbortError') setResultater(null);
 } finally {
 if (!signal.aborted) setIndlæser(false);
 }
 };
 useEffect(() => {
 if (søgetekst.length < 2) { setResultater(null); return; }
 clearTimeout(debounce_ref.current);
 debounce_ref.current = setTimeout(() => kør_fritekst_søg(), 400);
 return () => clearTimeout(debounce_ref.current);
 // eslint-disable-next-line react-hooks/exhaustive-deps
 }, [søgetekst]);
 // AI søgning — asynkron via kø, SSE-stream for resultat
 const kør_ai_søg = async () => {
 if (!søgetekst.trim()) return;
 setAiIndlæser(true);
 setAiFejl(null);
 setAiSvar(null);
 try {
   const init = await api("soeg/ai", "POST", { spørgsmål: søgetekst });
   if (!init?.opgave_id) {
     setAiFejl(init?.fejl || "AI-søgning er ikke tilgængelig lige nu — prøv igen senere.");
     setAiIndlæser(false);
     return;
   }
   const es = new EventSource(`/api/søg/ai/stream/${init.opgave_id}`);
   es.addEventListener('resultat', (e) => {
     es.close();
     try { setAiSvar(JSON.parse(e.data)); } catch (_) { setAiFejl("AI-søgning er ikke tilgængelig lige nu — prøv igen senere."); }
     setAiIndlæser(false);
   });
   es.addEventListener('fejl', (e) => {
     es.close();
     let besked = "AI-søgning er ikke tilgængelig lige nu — prøv igen senere.";
     try { besked = JSON.parse(e.data).fejl || besked; } catch (_) {}
     setAiFejl(besked);
     setAiIndlæser(false);
   });
   es.onerror = () => {
     es.close();
     setAiFejl("AI-søgning er ikke tilgængelig lige nu — prøv igen senere.");
     setAiIndlæser(false);
   };
 } catch (_) {
   setAiFejl("AI-søgning er ikke tilgængelig lige nu — prøv igen senere.");
   setAiIndlæser(false);
 }
 };
 const total = resultater
 ? (resultater.klienter?.length || 0) + (resultater.sager?.length || 0) + (resultater.haendelser?.length || 0) + (resultater.filer?.length || 0)
 : 0;
 const SAGSTYPER_MAP = { skilsmisse:"Skilsmisse", samvaer:"Samvær", bopael:"Bopæl", foraldremyndighed:"Forældremyndighed", boern_bidrag:"Børnebidrag", myndighedsdialog:"Myndighedsdialog", andet:"Andet" };
 // Render tekst med **fed** highlights fra FTS
 const highlight = (tekst) => {
 if (!tekst) return null;
 const dele = tekst.split(/\*\*(.+?)\*\*/g);
 return dele.map((del, i) =>
 i % 2 === 1
 ? React.createElement("strong", { key: i, style: { color: T.turkis, fontWeight: 700 } }, del)
 : del
 );
 };
 return (
 <div style={{ minHeight:"100vh", background:BG, paddingBottom:60 }}>
 {/* Logo vandmærke */}
 {/* Header fjernet — fælles topbar bruges */}
 <div style={{ padding:"clamp(16px, 3vw, 28px) clamp(16px, 4vw, 40px)", maxWidth:1200, margin:"0 auto" }}>
 {/* Søgefelt */}
 <div style={{ marginBottom:20 }}> <div style={{ fontSize:22, fontWeight:300, color:T.creme, marginBottom:18, textAlign:"center" }}>
 Søg på tværs af <span style={{ color:T.turkis }}>alle data</span> </div> <div style={{ position:"relative" }}> <span style={{ position:"absolute", left:18, top:"50%", transform:"translateY(-50%)", fontSize:18, color:T.dæmpet, pointerEvents:"none" }}></span> <input
 ref={input_ref}
 value={søgetekst}
 onChange={e => setSøgetekst(e.target.value)}
 onKeyDown={e => { if (e.key === "Enter") { e.preventDefault(); kør_fritekst_søg(); } }}
 placeholder='Søg fx "Barbara", "SV-1001", "møde med Familieretshuset"...'
 spellCheck="true" lang="da"
 className="sv-input"
 style={{
 width:"100%", background:"rgba(8,12,30,0.65)",
 border:`1px solid ${søgetekst.length > 1 ? T.turkis + "66" : "rgba(255,255,255,0.09)"}`,
 borderRadius:16, padding:"16px 220px 16px 52px",
 color:T.creme, fontSize:16, fontFamily:"'Inter',system-ui,sans-serif",
 boxSizing:"border-box", backdropFilter:"blur(16px)", WebkitBackdropFilter:"blur(16px)",
 }}
 /> <div style={{ position:"absolute", right:8, top:"50%", transform:"translateY(-50%)", display:"flex", gap:6 }}> <button
 onClick={() => kør_fritekst_søg()}
 disabled={indlæser || søgetekst.trim().length < 2}
 style={{
 background: indlæser ? "rgba(255,255,255,0.15)" : "rgba(255,255,255,0.2)",
 border:T.skillelinje, borderRadius:8, padding:"9px 14px",
 color:"#ffffff", fontWeight:600, fontSize:13,
 fontFamily:"'Inter',system-ui,sans-serif", cursor:indlæser||søgetekst.trim().length<2?"not-allowed":"pointer",
 opacity:søgetekst.trim().length<2?0.4:1, transition:"all 0.2s",
 display:"flex", alignItems:"center", gap:5,
 }}>
 {indlæser ? "" : ""} Søg
 </button> <button
 onClick={kør_ai_søg}
 disabled={ai_indlæser || søgetekst.trim().length < 2}
 style={{
 background: ai_indlæser ? "rgba(63,212,199,0.3)" : T.turkis,
 border:"none", borderRadius:8, padding:"9px 14px",
 color:"#ffffff", fontWeight:700, fontSize:13,
 fontFamily:"'Inter',system-ui,sans-serif", cursor:ai_indlæser||søgetekst.trim().length<2?"not-allowed":"pointer",
 opacity:søgetekst.trim().length<2?0.4:1, transition:"all 0.2s",
 display:"flex", alignItems:"center", gap:5,
 }}>
 {ai_indlæser ? " Analyserer..." : " AI-søg"}
 </button> </div> </div> <div className="sv-soeg-instruktion" style={{ fontSize:12, color:T.dæmpet, marginTop:8, textAlign:"center", display:"flex", alignItems:"center", justifyContent:"center", gap:6 }}>
 Tryk <strong style={{ color:T.creme }}>Enter</strong> eller <strong style={{ color:T.creme }}>Søg</strong> for fritekst · <strong style={{ color:T.turkis }}>AI-søg</strong> for naturlig sprogsøgning med AI
 <HjaelpIkon tekst="Fritekstsøg matcher eksakte ord i klientnavne, sagsnumre, hændelser og dokumenter (PostgreSQL full-text search med dansk stemming). AI-søg fortolker naturligt sprog — fx 'sager med deadline næste uge' eller 'modparter der er advokater' — og returnerer relevante sager med AI-genereret begrundelse." /> </div> </div>
 {/* AI svar */}
 {ai_svar && (
 <div className="sv-3d-tilt sv-animated-border" style={{ position:"relative", overflow:"hidden", background:"linear-gradient(135deg, rgba(10,38,38,0.95) 0%, rgba(8,30,50,0.95) 100%)", border:`1px solid ${T.turkis}44`, borderRadius:16, padding:"20px 22px", marginBottom:20, boxShadow:`0 8px 48px rgba(63,212,199,0.12), 0 0 60px rgba(63,212,199,0.05), inset 0 1px 0 rgba(63,212,199,0.1)`, animation:"sv-fadeup 0.4s cubic-bezier(0.34,1.56,0.64,1) both", backdropFilter:"blur(24px)", WebkitBackdropFilter:"blur(24px)" }}>
 {/* Accent strip */}
 <div style={{ position:"absolute", top:0, left:0, right:0, height:3, background:`linear-gradient(90deg, ${T.turkis}, #a78bfa, transparent)`, borderRadius:"16px 16px 0 0", pointerEvents:"none" }} />
 {/* Glow orb */}
 <div style={{ position:"absolute", top:-20, right:20, width:140, height:140, borderRadius:"50%", background:`${T.turkis}07`, filter:"blur(35px)", pointerEvents:"none" }} /> <div style={{ position:"relative", fontSize:12, letterSpacing:"0.18em", textTransform:"uppercase", color:T.turkis, marginBottom:10, display:"flex", alignItems:"center", gap:8 }}>
 AI-svar
 <span style={{ fontSize:12, color:T.dæmpet }}>— Claude analyserede din søgning</span> </div> <div style={{ fontSize:14, color:T.lys, lineHeight:1.75, whiteSpace:"pre-line" }}>{ai_svar.svar}</div>
 {ai_svar.relevante_sager?.length > 0 && (
 <div style={{ marginTop:14, display:"flex", flexWrap:"wrap", gap:8 }}>
 {ai_svar.relevante_sager.map(s => (
 <button key={s.sagsnummer} onClick={() => onÅbnSag(s.sagsnummer)}
 style={{ background:"rgba(63,212,199,0.12)", border:`1px solid ${T.turkis}44`, borderRadius:7, padding:"6px 14px", color:T.turkis, fontSize:12, fontFamily:"'Inter',system-ui,sans-serif", cursor:"pointer" }}>
 {s.sagsnummer} — {s.klient_navn} →
 </button>
 ))}
 </div>
 )}
 </div>
 )}
 {ai_fejl && (
 <div role="alert" style={{ background:"rgba(255,107,107,0.08)", border:"1px solid rgba(255,107,107,0.25)", borderRadius:10, padding:"14px 18px", marginBottom:20, fontSize:13, color:T.roed }}>
 {ai_fejl}
 </div>
 )}
 {/* Indlæser fritekst */}
 {indlæser && (
 <div style={{ textAlign:"center", padding:"24px", color:T.dæmpet, fontSize:13 }}>Søger...</div>
 )}
 {/* Fritekst resultater */}
 {!indlæser && resultater && (
 <> <div style={{ fontSize:12, color:T.dæmpet, marginBottom:16 }}>
 {total === 0 ? `Ingen resultater for "${søgetekst}"` : `${total} resultat${total !== 1 ? "er" : ""} for "${søgetekst}"`}
 </div>
 {/* Klienter */}
 {resultater.klienter?.length > 0 && (
 <div style={{ marginBottom:20 }}> <div style={{ fontSize:12, letterSpacing:"0.18em", textTransform:"uppercase", color:T.dæmpet, marginBottom:10 }}> Klienter</div> <div className="sv-3d-tilt" style={{ position:"relative", background:"rgba(8,12,30,0.55)", border:"1px solid rgba(255,255,255,0.07)", borderRadius:16, overflow:"hidden", backdropFilter:"blur(16px)", WebkitBackdropFilter:"blur(16px)" }}> <div style={{ position:"absolute", top:0, left:0, right:0, height:2, background:`linear-gradient(90deg, ${T.turkis}88, ${T.turkis}22, transparent)`, pointerEvents:"none", zIndex:1 }} />
 {resultater.klienter.map((k, i) => (
 <div key={k.id} style={{ padding:"13px 18px", borderBottom:i<resultater.klienter.length-1?T.skillelinje:"none", display:"flex", alignItems:"center", gap:12, cursor:"pointer", transition:"background 0.15s" }}
 onMouseOver={e=>e.currentTarget.style.background="rgba(255,255,255,0.04)"}
 onMouseOut={e=>e.currentTarget.style.background="transparent"}
 onClick={() => onÅbnSag(null, k.id)}> <div style={{ width:36, height:36, borderRadius:"50%", background:`${T.turkis}18`, border:`1px solid ${T.turkis}33`, display:"flex", alignItems:"center", justifyContent:"center", fontSize:14, color:T.turkis, flexShrink:0 }}>
 {(k.fornavn||"?")[0]}{(k.efternavn||"")[0]}
 </div> <div style={{ flex:1, minWidth:0 }}> <div style={{ fontSize:14, fontWeight:500, color:T.creme }}>{k.fornavn} {k.efternavn}</div> <div style={{ fontSize:12, color:T.dæmpet }}>{k.telefon} {k.email ? "· " + k.email : ""}</div> </div> <div style={{ fontSize:12, color:T.dæmpet }}>{k.by || ""}</div> </div>
 ))}
 </div> </div>
 )}
 {/* Sager */}
 {resultater.sager?.length > 0 && (
 <div style={{ marginBottom:20 }}> <div style={{ fontSize:12, letterSpacing:"0.18em", textTransform:"uppercase", color:T.dæmpet, marginBottom:10 }}> Sager</div> <div className="sv-3d-tilt" style={{ position:"relative", background:"rgba(8,12,30,0.55)", border:"1px solid rgba(255,255,255,0.07)", borderRadius:16, overflow:"hidden", backdropFilter:"blur(16px)", WebkitBackdropFilter:"blur(16px)" }}> <div style={{ position:"absolute", top:0, left:0, right:0, height:2, background:"linear-gradient(90deg, #60a5fa88, #60a5fa22, transparent)", pointerEvents:"none", zIndex:1 }} />
 {resultater.sager.map((s, i) => (
 <div key={s.id} style={{ padding:"13px 18px", borderBottom:i<resultater.sager.length-1?T.skillelinje:"none", display:"flex", alignItems:"center", gap:12, cursor:"pointer", transition:"background 0.15s" }}
 onMouseOver={e=>e.currentTarget.style.background="rgba(255,255,255,0.04)"}
 onMouseOut={e=>e.currentTarget.style.background="transparent"}
 onClick={() => onÅbnSag(s.sagsnummer)}> <div style={{ flex:1, minWidth:0 }}> <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:3 }}> <div style={{ fontSize:14, fontWeight:500, color:T.creme }}>{s.klient_navn}</div> <span style={{ fontSize:12, letterSpacing:"0.1em", textTransform:"uppercase", padding:"1px 7px", borderRadius:4, color:T.turkis, background:`${T.turkis}18`, border:`1px solid ${T.turkis}33` }}>{s.sagsnummer}</span> </div> <div style={{ fontSize:12, color:T.dæmpet }}>{SAGSTYPER_MAP[s.type] || s.type || "—"} · {s.status}</div>
 {s.klient_maal && <div style={{ fontSize:12, color:T.dæmpet, marginTop:3, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{s.klient_maal.slice(0,80)}{s.klient_maal.length>80?"...":""}</div>}
 </div> <div style={{ fontSize:12, color:T.dæmpet }}>→</div> </div>
 ))}
 </div> </div>
 )}
 {/* Hændelser */}
 {resultater.haendelser?.length > 0 && (
 <div style={{ marginBottom:20 }}> <div style={{ fontSize:12, letterSpacing:"0.18em", textTransform:"uppercase", color:T.dæmpet, marginBottom:10 }}> Hændelser</div> <div style={{ position:"relative", background:"rgba(8,12,30,0.55)", border:"1px solid rgba(255,255,255,0.07)", borderRadius:16, overflow:"hidden", backdropFilter:"blur(16px)", WebkitBackdropFilter:"blur(16px)" }}> <div style={{ position:"absolute", top:0, left:0, right:0, height:2, background:"linear-gradient(90deg, #a78bfa88, #a78bfa22, transparent)", pointerEvents:"none", zIndex:1 }} />
 {resultater.haendelser.map((h, i) => (
 <div key={h.id} style={{ padding:"13px 18px", borderBottom:i<resultater.haendelser.length-1?T.skillelinje:"none", cursor:"pointer", transition:"background 0.15s" }}
 onMouseOver={e=>e.currentTarget.style.background="rgba(255,255,255,0.04)"}
 onMouseOut={e=>e.currentTarget.style.background="transparent"}
 onClick={() => onÅbnSag(h.sagsnummer)}> <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:4 }}> <div style={{ fontSize:13, fontWeight:500, color:T.lys }}>{highlight(h.titel_highlight || h.titel)}</div> <div style={{ fontSize:12, color:T.dæmpet, flexShrink:0, marginLeft:12 }}>{h.oprettet_dato ? new Date(h.oprettet_dato).toLocaleDateString("da-DK") : ""}</div> </div> <div style={{ fontSize:12, color:T.dæmpet, marginBottom:4 }}>{h.sagsnummer} · {h.klient_navn}{h.forfatter_navn ? " · " + h.forfatter_navn : ""}</div>
 {(h.beskrivelse_highlight || h.beskrivelse) && <div style={{ fontSize:12, color:"#b0bec5", lineHeight:1.5, overflow:"hidden", textOverflow:"ellipsis", display:"-webkit-box", WebkitLineClamp:2, WebkitBoxOrient:"vertical" }}>{highlight(h.beskrivelse_highlight || h.beskrivelse)}</div>}
 </div>
 ))}
 </div> </div>
 )}
 {/* Filer */}
 {resultater.filer?.length > 0 && (
 <div style={{ marginBottom:20 }}> <div style={{ fontSize:12, letterSpacing:"0.18em", textTransform:"uppercase", color:T.dæmpet, marginBottom:10 }}> Filer</div> <div style={{ position:"relative", background:"rgba(8,12,30,0.55)", border:"1px solid rgba(255,255,255,0.07)", borderRadius:16, overflow:"hidden", backdropFilter:"blur(16px)", WebkitBackdropFilter:"blur(16px)" }}> <div style={{ position:"absolute", top:0, left:0, right:0, height:2, background:"linear-gradient(90deg, #ffd43b88, #ffd43b22, transparent)", pointerEvents:"none", zIndex:1 }} />
 {resultater.filer.map((f, i) => (
 <div key={f.id} style={{ padding:"13px 18px", borderBottom:i<resultater.filer.length-1?T.skillelinje:"none", cursor:"pointer", transition:"background 0.15s" }}
 onMouseOver={e=>e.currentTarget.style.background="rgba(255,255,255,0.04)"}
 onMouseOut={e=>e.currentTarget.style.background="transparent"}
 onClick={() => onÅbnSag(f.sagsnummer)}> <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:4 }}> <div style={{ fontSize:13, fontWeight:500, color:T.lys }}>{f.visningsnavn || f.original_navn}</div> <div style={{ fontSize:12, color:T.dæmpet, flexShrink:0, marginLeft:12 }}>{f.sagsnummer}</div> </div> <div style={{ fontSize:12, color:T.dæmpet, marginBottom:4 }}>{f.klient_navn}</div>
 {f.tekst_highlight && <div style={{ fontSize:12, color:"#b0bec5", lineHeight:1.5, overflow:"hidden", textOverflow:"ellipsis", display:"-webkit-box", WebkitLineClamp:2, WebkitBoxOrient:"vertical" }}>{highlight(f.tekst_highlight)}</div>}
 </div>
 ))}
 </div> </div>
 )}
 {total === 0 && søgetekst.length >= 2 && (
 <div style={{ textAlign:"center", padding:"40px 20px" }}> <div style={{ fontSize:32, marginBottom:12 }}></div> <div style={{ fontSize:15, color:T.lys, marginBottom:8 }}>Ingen resultater fundet</div> <div style={{ fontSize:13, color:T.dæmpet }}>Prøv AI-søgning for naturlig sprogsøgning — klik <strong style={{ color:T.turkis }}> AI-søg</strong> ovenfor</div> </div>
 )}
 </>
 )}
 {/* Tom tilstand */}
 {!indlæser && !resultater && !ai_svar && (
 <div style={{ textAlign:"center", padding:"48px 20px" }}> <div style={{ fontSize:40, marginBottom:16 }}></div> <div style={{ fontSize:14, color:T.dæmpet, lineHeight:1.8 }}>
 Søg på tværs af alle klienter, sager og hændelser<br />
 Brug <strong style={{ color:T.turkis }}>AI-søg</strong> til naturligt sprog, fx:<br /> <span style={{ color:"#b0bec5", fontStyle:"italic" }}>"SMS fra Barbara i juni"</span> eller <span style={{ color:"#b0bec5", fontStyle:"italic" }}>"møder med Familieretshuset"</span> </div> </div>
 )}
 </div> </div>
 );
}
// ─────────────────────────────────────────────────────────
export { SøgVisning, OmdøbFilKnap, FilViewer };